import React from 'react';
interface Props
	extends React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement>,
		React.DetailedHTMLProps<React.ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement> {
	header?: boolean;
	onClick?: React.MouseEventHandler<any>;
	input?: boolean;
	dropDownOptions?: Array<{
		name: string;
		value: string;
	}>;
	inputValue?: string;
	placeholder?: string;
	inputLabel?: string;
	disabled?: boolean;
	onInputChange?: (text: string) => void;
}

const PbCell: React.FC<Props> = (props) => {
	let html: JSX.Element;

	if (props.header) {
		html = (
			<th className={`${props.className || ''}`} onClick={props.onClick} colSpan={props.colSpan} rowSpan={props.rowSpan} style={props.style}>
				{typeof props.children === 'string' ? props.children : props.children}
			</th>
		);
	} else {
		html = (
			<td
				className={[props.className, 'Cell'].join(' ')}
				colSpan={props.colSpan}
				rowSpan={props.rowSpan}
				style={props.style}
				onClick={props.onClick}
			>
				{props.children}
			</td>
		);
	}

	return html;
};
export default PbCell;
